import WorkScheduleHelpers from "../../services/helpers/WorkScheduleHelpers";
import classnames from "classnames";
import useMenu from "../../hooks/menu/useMenu";
import useAppMethods from "../../hooks/utility/useAppMethods";
import { OpeningHoursInterface} from "../../services/exports/Interfaces";
import {ReactElement} from "react";
import {useSelector} from "react-redux";
import {StoreInterface} from "../../store/types";
import {useTranslation} from "react-i18next";

interface Props {
  className?: string;
}

export default function MenuList(props: Props): ReactElement {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Menu:MenuList' });

  const { className } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { menus, selectedMenu, setSelectedMenu } = useMenu();
  const { formatScheduleUnit } = useAppMethods();

  return menus.count() === 1 ? null : (
    <div>
      <h5>{t('header')}</h5>
      <div className={classnames('flex mt-small overflow-x-auto scrollbar-hide', className)}>
        {menus.map((item, index) => (
          <div
            key={`${selectedMenu?.id}-company-menu-${item?.id}-${index}`}
            className={classnames(
              'mr-medium px-mini py-tiny group cursor-pointer text-center rounded-lg',
              {
                'bg-companyBrand-primary text-white': item?.id === selectedMenu?.id,
                'border border-[#DEDEDE]': item?.id !== selectedMenu?.id,
              }
            )}
            onClick={() => setSelectedMenu(item)}
          >
            <h6 className="uppercase text-mini">
              {item?.name}
            </h6>
            <p className="mt-tiny text-tiny">
              {WorkScheduleHelpers.formatSchedule(
                item?.schedule ?? company?.work_schedule,
                (item: OpeningHoursInterface) => `${formatScheduleUnit(item.open)} - ${formatScheduleUnit(item.close)}`
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}